module.exports = __webpack_public_path__ + "static/google-play-badge-558628d4ba7c96e7358c3ba40206f4a0.png";